"use client";

import classNames from "classnames";
import styles from "./styles/LoginButtons.module.scss";
import LoginButton, { type LoginButtonType } from "./LoginButton";
import MagicLinkForm from "./MagicLinkForm";
import { useStores } from "../../../../../stores/useStores";
import { useFeatureFlags } from "../../../../../utils/featureFlags/useFeatureFlags";
import { useState } from "react";
import { isSchoolBlocksApp } from "../../../../../utils/SchoolBlocksUtilities";

const loginButtonsContainerClassName = classNames({
  [styles.loginButtonsContainer]: true,
});

export type ILoginRole = "student" | "guardian" | "staff" | "other";

export default function LoginButtons() {
  const { organizationStore } = useStores();
  const { magic_link_enabled } = useFeatureFlags();

  const requiresUserRole =
    ["school", "district"].includes(organizationStore.organization.type) &&
    organizationStore.organization.json_data.settings?.identity?.passport
      ?.orgGuid;
  const [role, setRole] = useState<"" | ILoginRole>("");

  let oauthProviders = ["google", "office", "facebook"];
  if (requiresUserRole && ["student", "staff"].includes(role)) {
    oauthProviders = ["passport"];
  }

  const showMagicLink =
    magic_link_enabled &&
    (isSchoolBlocksApp() ? requiresUserRole && role === "guardian" : true);

  return (
    <div className={loginButtonsContainerClassName}>
      {requiresUserRole && (
        <div>
          Select your role within {organizationStore.organization.title}:
          <div>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value as ILoginRole)}
            >
              <option value={""}>Select a role...</option>
              <option value={"student"}>Student</option>
              <option value={"guardian"}>Parent/Guardian</option>
              <option value={"staff"}>Staff</option>
              <option value={"other"}>Other</option>
            </select>
          </div>
        </div>
      )}
      {((requiresUserRole && role) || !requiresUserRole) && (
        <>
          <ul>
            {oauthProviders.map((item, i) => {
              return (
                <li key={i}>
                  <LoginButton
                    role={role === "other" ? "" : role}
                    type={item as LoginButtonType}
                  />
                </li>
              );
            })}
          </ul>
          {showMagicLink && (
            <>
              <div className={styles.magicLinkSeparator}>
                or sign in with email
              </div>
              <MagicLinkForm role={role} />
            </>
          )}
        </>
      )}
    </div>
  );
}
